module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'text-success': _vm.value > 0, 'text-danger': _vm.value < 0
    }
  }, [(_vm.value !== 0) ? _c('span', [_vm._v(_vm._s(Math.round(_vm.value)) + "\n    "), (_vm.isPercentage) ? _c('span', [_vm._v("%")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa",
    class: {
      'fa-level-up': _vm.value > 0,
        'fa-level-down': _vm.value < 0,
        'fa-minus': _vm.value === 0
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c6e774e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/common/Growth.vue
// module id = 3134
// module chunks = 3